import { render } from "./ViewBotConfiguration.vue?vue&type=template&id=56251b4d&scoped=true"
import script from "./ViewBotConfiguration.vue?vue&type=script&lang=js"
export * from "./ViewBotConfiguration.vue?vue&type=script&lang=js"

import "./ViewBotConfiguration.vue?vue&type=style&index=0&id=56251b4d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56251b4d"]])

export default __exports__